import type { ButtonFeeling, ButtonRole, ButtonSize } from "./types";

export const feelingColor: Record<
    ButtonFeeling,
    "primary" | "critical" | "positive" | "neutral" | "warning" | "media" | "inherit"
> = {
    danger: "critical",
    normal: "primary",
    minor: "neutral",
};

export const roleVariant: Record<ButtonRole, "solid" | "outline" | "ghost"> = {
    main: "solid",
    side: "outline",
    minor: "ghost",
};

export const buttonSize: Record<ButtonSize, "xlarge" | "large" | "medium" | "small"> = {
    huge: "xlarge",
    big: "large",
    normal: "medium",
    small: "small",
};
